export type ApiEnvKey = 'production' | 'homologation';

export interface ApiEnvironment {
  label: string;
  apiRoot: string;
}

/** API do admin oficial https://administrator-parleite.web.app/ */
export const PRODUCTION_API_ROOT = 'https://api.staging.homeleite.com.br/';

export const API_ENVIRONMENTS: Readonly<Record<ApiEnvKey, ApiEnvironment>> = {
  // Sempre a mesma API do administrator-parleite (não depender do environment.apiRoot do build HML).
  production: { label: 'Produção', apiRoot: PRODUCTION_API_ROOT },
  homologation: {
    label: 'Homologação',
    apiRoot: 'https://homolog-homeleite.racaholandesa.com.br/',
  },
};

export const ENV_STORAGE_KEY = 'homeleiteAdmin.env';
const LEGACY_TOKEN_KEY = 'homeleiteAdmin.authToken';
/** Prefixo legado; o valor efetivo é por ambiente via currentInfoCacheKeyFor(). */
export const CURRENT_CACHE_KEY_PREFIX = 'homeleite.cache.current';

export function currentApiEnvKey(): ApiEnvKey {
  try {
    const v = localStorage.getItem(ENV_STORAGE_KEY);
    // Respeita a escolha explícita do banner (Produção ou Homologação).
    // Antes só 'homologation' era lido do storage; em admin-homolog o host
    // forçava homologação de novo e a troca para Produção parecia não fazer nada.
    if (v === 'homologation' || v === 'production') {
      return v;
    }
  } catch {
    // sem storage: cai no default por host
  }
  return location.hostname === 'admin-homolog.racaholandesa.com.br' ? 'homologation' : 'production';
}

export function currentApiEnvironment(): ApiEnvironment {
  return API_ENVIRONMENTS[currentApiEnvKey()];
}

export function authTokenKeyFor(key: ApiEnvKey): string {
  return `${LEGACY_TOKEN_KEY}.${key}`;
}

export function currentInfoCacheKeyFor(key: ApiEnvKey = currentApiEnvKey()): string {
  return `${CURRENT_CACHE_KEY_PREFIX}.${key}`;
}

export function switchApiEnvironment(key: ApiEnvKey): void {
  try {
    localStorage.setItem(ENV_STORAGE_KEY, key);
    // limpa cache legado e por ambiente
    localStorage.removeItem(CURRENT_CACHE_KEY_PREFIX);
    localStorage.removeItem(currentInfoCacheKeyFor('production'));
    localStorage.removeItem(currentInfoCacheKeyFor('homologation'));
  } catch {
    // sem storage: troca não persiste
  }
  location.reload();
}
